import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import CollaborateTour from "components/Tour/CollaborateTour";

import {
  updateCollaborateTourIsOpen,
  updateCollaborateStep,
  getCollaborateIsOpen,
  getCollaborateStep
} from "containers/Tour/reducer";
import { updateMode } from "containers/Consumer/reducer";

class CollaborateTourContainer extends React.PureComponent {
  render() {
    return <CollaborateTour {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpen: (isOpen) => dispatch(updateCollaborateTourIsOpen(isOpen)),
    updateStep: (step) => dispatch(updateCollaborateStep(step)),
    updateMode: (mode) => dispatch(updateMode(mode))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: getCollaborateIsOpen(state),
    step: getCollaborateStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CollaborateTourContainer);
